import clsx from 'clsx'
import React, {FC, PropsWithChildren, useMemo} from 'react'
import {HeaderProps} from 'react-table'
import {initialQueryState, QueryState} from '../../_metronic/helpers'

type Props = {
  className?: string
  title?: string | React.ReactNode
  tableProps: PropsWithChildren<HeaderProps<any>>
  state: QueryState
  updateState: (state: QueryState) => void
  sortable?: boolean
  sortField?: string
}

export const Thead: FC<Props> = ({
  className,
  title,
  tableProps,
  state,
  updateState,
  sortable,
  sortField,
}) => {
  const id = tableProps.column.id
  const isSelectedForSorting = useMemo(() => {
    return state.sort_field && state.sort_field === id
  }, [state, id])

  const sort_order: 'asc' | 'desc' | undefined = useMemo(() => state.sort_order, [state])

  const sortColumn = () => {
    updateState({
      ...initialQueryState,
      sort_field: sortField || id,
      sort_order: sort_order === 'asc' ? 'desc' : 'asc',
    })
  }

  return (
    <th
      {...tableProps.column.getHeaderProps()}
      className={clsx(
        'px-4 py-3 text-left text-sm font-semibold text-gray-700 uppercase tracking-wider',
        sortable && 'cursor-pointer select-none',
        isSelectedForSorting && sort_order === 'asc' && 'bg-gray-100',
        isSelectedForSorting && sort_order === 'desc' && 'bg-gray-200',
        className
      )}
      onClick={sortable ? sortColumn : undefined}
    >
      {title}
    </th>
  )
}
